<template>
  <div>
    <img
      v-if="productImage != null && productImage != ''"
      data-toggle="modal"
      data-target="#exampleModalLabel"
      :src="productImage"
      :class="[popUpImage ? 'pointer' : '', 'image_box']"
      @click="showImage(productImage)"
    >
    <img
      v-else
      :src="getNoImage()"
      class="image_box"
    >

    <div
      class="modal fade"
      v-if="isModalImages && popUpImage"
      tabindex="-1"
      role="dialog"
      id="exampleModalLabel"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="closeModal()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div
              id="carouselExampleControls"
              class="carousel slide"
              data-ride="carousel"
            >
              <div class="carousel-inner">
                <div
                  class="carousel-item active"
                >
                  <img
                    class="d-block w-100 h-100"
                    :src="productImage"
                  >
                </div>
              </div>
              <a
                class="carousel-control-prev"
                href="#carouselExampleControls"
                role="button"
                data-slide="prev"
              >
                <div class="carousel-control-prev-icon-bg">
                  <span
                    class="carousel-control-prev-icon"
                    aria-hidden="true"
                  />
                </div>
                <span class="sr-only">Previous</span>
              </a>
              <a
                class="carousel-control-next circle"
                href="#carouselExampleControls"
                role="button"
                data-slide="next"
              >
                <div class="carousel-control-next-icon-bg">
                  <span
                    class="carousel-control-next-icon"
                    aria-hidden="true"
                  />
                  <span class="sr-only">Next</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    productId:{
      type: [Number, String],
      default: undefined
    },
    productImageUrl: {
      type: [Object, Array, String],
      default: null
    },
    popUpImage:{
      type: [Boolean],
      default: true
    },
    moduleType:{
      type: String,
      default: null
    }
  },
  data() {
    return {
      productImage: "",
      isModalImages: false,
      showBigImage: "",
    };
  },
  mounted() {
  },
  watch: {
    productImageUrl: {
      immediate: true,
      handler(val) {
        this.getImage(val);
      },
    }
  },
  methods: {
    getImage(dataImageUrl){
      this.productImage = null;
      if(dataImageUrl != null && dataImageUrl.length){
        if (typeof dataImageUrl == 'string') {
          this.productImage = dataImageUrl;
        }
        else {
          this.productImage = dataImageUrl[0];
        }
      }
    },
    getNoImage(){
      let image = this.$storeIndex.getImageGobalAssets('');
      if(this.moduleType == 'category'){
        image = require('@/assets/images/no-category-image.png');
      }
      return image;
    },
    showImage(productImage) {
      if(this.popUpImage){
        this.isModalImages = false;
        this.showBigImage = "";

        if(productImage){
          this.showBigImage = productImage;
          this.isModalImages = true;
        }
      }
    },
    closeModal(){
      this.showBigImage = "";
      this.isModalImages = false;
    },
  }
}
</script>
<style scoped>
.fade {
    pointer-events: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/center/ProductImageComponent.vue